// import {scroller} from 'vue-scrollto/src/scrollTo'

export const timelineMixin = {
    props: {
        exibindoEm: {
            type: String,
            required: false,
            default: ""
        },

        quadroAtualLoop: {
            type: [Boolean, Object],
            required: false,
            default: null
        },

        currentSlideIndex: {
            required: false,
            default: null
        },
    },

    // data() {
    //     return {
    //
    //     };
    // },

    computed: {
        //replaced by getDivisaoQuadroAtualLoop(numDivisao)
        // cpLayoutDivisoes() {
        //     if (!this.quadroAtualLoop) {
        //         return null;
        //     }
        //
        //     return this.quadroAtualLoop.layoutDivisoes ?? null;
        //
        //     // if (this.exibindoEm == 'player') {
        //     //     return this.quadroAtualLoop.layoutDivisoes;
        //     // }else{
        //     //     return this.$store.getters.getDivisoes;
        //     // }
        // },

        //todo-later ver pq esta sendo chamado tantas vezes ao selecionar um tipo de layout e tbm
        // pra selecionar um componente
        // getDivisaoQuadroAtualLoop() {
        //     return numDivisao => {
        //
        //         if (!this.quadroAtualLoop) {
        //             return null;
        //         }
        //
        //         return this.quadroAtualLoop.layoutDivisoes[numDivisao] ?? null;
        //     }
        // },

        cpGetDivisaoEmEdicao() {
            return this.$store.getters.getDivisaoEmEdicao;
        },
    },

    methods: {
        scrollIntervalStart(container) {
            let delay = 6000;
            let step = 3;
            let scrollPointNumber = step;

            var interval = setInterval((thiz) => {
                if (window.document.getElementById(`${container}_scrollPoint_1`) != null) {
                    if (window.document.getElementById(`${container}_scrollPoint_${scrollPointNumber}`) == null) {
                        // clearInterval(interval);
                        window.document.getElementById(`${container}`).scrollTo(0,0);
                        scrollPointNumber = step;
                    }

                    thiz.scrollDivisaoX(container, scrollPointNumber);
                    scrollPointNumber += step;
                }
            }, delay, this);
        },

        scrollDivisaoX(container, scrollPointNumber) {
            // const scrollTo1 = scroller();
            // const scrollTo3 = scroller();

            let duration = 800;
            this.$scrollTo(`#${container}_scrollPoint_${scrollPointNumber}`, duration, {
                container: '#' + container,
                easing: 'ease-in',
                offset: 0,
                force: true,
                cancelable: false,
                // onStart: function(element) {
                //     // scrolling started
                // },
                // onDone: (element) => {
                //     clearInterval(this.interval1);
                // },
                // onCancel: function() {
                //     // scrolling has been interrupted
                // },
                x: false,
                y: true
            });
            // if (numDivisao == 1) {
            //     scrollTo1('#scrollPoint_' + numDivisao + '_' + scrollPointNumber, duration, {
            //         container: '#divisao' + numDivisao,
            //         easing: 'ease-in',
            //         offset: 0,
            //         force: true,
            //         cancelable: false,
            //         // onStart: function(element) {
            //         //     // scrolling started
            //         // },
            //         // onDone: (element) => {
            //         //     clearInterval(this.interval1);
            //         // },
            //         // onCancel: function() {
            //         //     // scrolling has been interrupted
            //         // },
            //         x: false,
            //         y: true
            //     });
            // }

            // if (numDivisao == 3) {
            //     scrollTo3('#scrollPoint_' + numDivisao + '_' + scrollPointNumber, duration, {
            //         container: '#divisao' + numDivisao,
            //         easing: 'ease-in',
            //         offset: 0,
            //         force: true,
            //         cancelable: true,
            //         // onStart: function(element) {
            //         //     // scrolling started
            //         // },
            //         // onDone: (element) => {
            //         //     clearInterval(this.interval3);
            //         // },
            //         // onCancel: function() {
            //         //     // scrolling has been interrupted
            //         // },
            //         x: false,
            //         y: true
            //     });
            // }
        },

        getDivisaoQuadroAtualLoop(numDivisao) {
            if (!this.quadroAtualLoop) {
                return null;
            }

            return this.quadroAtualLoop.layoutDivisoes[numDivisao] ?? null;
        },

        getDivisaoEmEdicaoConfigs() {
            let configs = null;

            if (this.$store.getters.getDivisaoEmEdicao) {
                configs = this.$store.getters.getDivisaoEmEdicao.configs;
            }

            return configs;
        },

        setDivisaoNumeroEmEdicao(i) {
            this.$store.commit('setTimelineDivisaoNumeroEmEdicao', i);
        },

        rmCartazMeioElemento(i) {
            this.$store.commit('rmCartazMeioElemento', i);
        },

        setMeioElementoEmEdicaoIndex(i) {
            this.$store.commit('setMeioElementoEmEdicaoIndex', i);
        },

        getMeioElementoEmEdicao() {
            if (this.$store.getters.getMeioElementoEmEdicao) {
                return this.$store.getters.getMeioElementoEmEdicao;
            }

            return null;
        },

        formataPrecoPlayer(preco){
            //R${{ (el.mercDataAux.preco || 'X,XX').replace('.', ',') }}
            if(parseFloat(preco) > 0){
                return preco.replace('.', ',');
            }

            return 'X,XX';
        },
    },
};
